import React from "react";

export enum ScreenSize {
  XXSmall,
  XSmall,
  Small,
  Medium,
  Large
}

export interface ScreenProps {
  width: number;
  height: number;
  screenSize: ScreenSize;
}

export const getScreenSize = (width: number) => {
  if (width <= 768) {
    return ScreenSize.XXSmall;
  }
  if (width <= 1050) {
    return ScreenSize.XSmall;
  }
  if (width > 1050 && width <= 1415) {
    return ScreenSize.Small;
  }
  if (width > 1415 && width <= 1745) {
    return ScreenSize.Medium;
  }
  return ScreenSize.Large;
}

export function useWindowSize() {
  const [windowSize, setWindowSize] = React.useState<ScreenProps>({
    width: window.innerWidth,
    height: window.innerHeight,
    screenSize: getScreenSize(window.innerWidth)
  });

  React.useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleResize = () => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
      screenSize: getScreenSize(window.innerWidth)
    });
  }

  return windowSize;
}